<template>
   
  <div class="home">
    <h1>CMS</h1>
    <div class="tips">欢迎使用CMS</div>
  </div>
</template>

<script>
  import editor from '@/components/editor/editor.vue'
  export default {
    name: 'home',
    components: {
      editor,
    },
    data() {
      return {}
    },
  }
</script>

<style scoped lang="less">
  .home {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>
